import React, { useState, useCallback } from 'react';
import { useLocation, useRouteMatch } from 'react-router-dom';
import {
  Form,
  Header,
  Container,
  CardInputBox,
  CardInput,
  CardButtonPass,
  CardImg,
  MyLoginButton,
} from './styledLoginComp';
import slashEye from './eye-slash.svg';
import eye from './eye.svg';
import useAuth from './hooks/useAuth';
import LoginMsg from './loginMsg';

const PASSWORD_CHARS = '0123456789abcdefghijklmnopqrstuvwxyz_$!ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const PASSWORD_LENGTH = 8;

function Activation() {
  const [confirmPass, setConfirmPass] = useState();
  const [pass, setPass] = useState();
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showMsg, setShowMsg] = useState('');

  const { pathname } = useLocation();

  const { url } = useRouteMatch();

  const lenUrl = url.trim().length;

  window.localStorage.removeItem('refreshToken');
  window.localStorage.removeItem('accessToken');
  window.localStorage.removeItem('ticket');

  const uidActivateToken = pathname.trim().slice(lenUrl + 1);

  const posSlash = uidActivateToken.search('/');
  const activateToken = uidActivateToken.slice(posSlash + 1);

  const uid = uidActivateToken.slice(0, posSlash);

  const { ativationNewPassHandler } = useAuth();

  const onGeneratePassword = useCallback(
    () => {
      const newPassword = [...Array(PASSWORD_LENGTH)].reduce((R) => {
        const r = Math.floor(Math.random() * PASSWORD_CHARS.length);
        return R + PASSWORD_CHARS.substring(r, r + 1);
      }, '');
      setPass(newPassword);
      setConfirmPass(newPassword);
    },
    [],
  );

  const activationHandler = useCallback(() => {
    if (pass === confirmPass) {
      ativationNewPassHandler({
        uid,
        token: activateToken,
        new_password: pass,
        re_new_password: pass,
        setShowMsg,
      });
    } else {
      setShowMsg('Паролі не співпадають');
    }
  }, [activateToken, ativationNewPassHandler, confirmPass, pass, uid]);

  return (
    <Container>
      <Form>
        <Header>Перевстановлення паролю</Header>
        <br />
        <CardInputBox style={{ marginLeft: '-1px' }}>
          <CardImg>
            <CardInput
              autocomplete="new-password"
              placeholder="Введіть новий пароль"
              name="Пароль"
              value={pass}
              type={showPass ? 'text' : 'password'}
              className="card-input"
              onChange={(e) => setPass(e.target.value)}
            />
            <CardButtonPass
              onClick={() => setShowPass(!showPass)}
            >
              <img
                src={showPass ? slashEye : eye}
                alt="Показати пароль"
              />
            </CardButtonPass>
          </CardImg>
        </CardInputBox>
        <br />
        <CardInputBox style={{ marginLeft: '-1px' }}>
          <CardImg>
            <CardInput
              autocomplete="new-password"
              placeholder="Введіть новий пароль ще раз"
              name="Пароль"
              value={confirmPass}
              type={showConfirmPass ? 'text' : 'password'}
              className="card-input"
              onChange={(e) => setConfirmPass(e.target.value)}
            />
            <CardButtonPass
              onClick={() => setShowConfirmPass(!showConfirmPass)}
            >
              <img
                src={showConfirmPass ? slashEye : eye}
                alt="Показати пароль"
              />
            </CardButtonPass>
          </CardImg>
        </CardInputBox>
        <br />
        <MyLoginButton
          content="Згенерувати пароль"
          key="btnGeneratePassword"
          onClick={() => {
            onGeneratePassword();
          }}
        />
        <div style={{ marginTop: '10px' }}>
          <MyLoginButton
            content="Встановити"
            key="btnActivationHandler"
            onClick={() => {
              activationHandler();
            }}
          />
        </div>
      </Form>
      {showMsg && (
      <LoginMsg
        open={showMsg}
        msg={showMsg}
      />
      )}
    </Container>
  );
}

export default Activation;
